const id_sales_returncustomer = {
    "": "retur pelanggan",
    type: "metode retur",

    label: {
        ref_itemout: "referensi barang keluar",
        no_trans_out: "nomor transaksi barang keluar",
    },

    error: {
        create: "Gagal membuat retur pelanggan.",
        edit: "Gagal mengubah retur pelanggan.",
        type: "Jenis retur tidak boleh kosong.",
        sn_not_found: "Barang dengan serial number: {{sn}} masih berada di gudang atau belum terdaftar.",
    },

    success: {
        create: "Berhasil membuat retur pelanggan.",
        edit: "Berhasil mengubah retur pelanggan.",
    },
}

export default id_sales_returncustomer;